import { Component, Input, OnInit } from '@angular/core';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { MatTooltip } from '@angular/material/tooltip';
import { Device, DeviceUtils } from '@deprecated/api-interfaces';
import { IconComponent } from '@ird/ng-base';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { TenantService } from '../../services';

@Component({
  selector: 'shared-device-icons',
  templateUrl: './device-icons.component.html',
  imports: [IconComponent, MatTooltip, TranslatePipe, FlexLayoutModule],
})
export class DeviceIconsComponent implements OnInit {
  @Input() device!: Device;

  public timeOutDuration!: number;
  public timeOutUnit!: string;

  constructor(
    private tenantService: TenantService,
    private translateService: TranslateService,
  ) {}

  public ngOnInit(): void {
    const durationInNanoSec = this.device.timeoutDuration;
    const returnObj = this.tenantService.convertTimeoutDurationDynamic(durationInNanoSec);
    if (returnObj) {
      this.timeOutDuration = returnObj.value;
      this.timeOutUnit = this.translateService.instant('ADMINISTRATION.TENANT.FEATURES.TIMEOUT_DURATION.' + returnObj.unit.toUpperCase());
    }
  }

  public isMonitored(device: Device): boolean {
    return DeviceUtils.isMonitored(device);
  }

  public isInProvisioning(device: Device): boolean {
    return DeviceUtils.isInProvisioning(device);
  }

  public isOnline(device: Device): boolean {
    return DeviceUtils.isOnline(device);
  }
}
